module.exports = __webpack_public_path__ + "img/clock.06bf9a92.svg";